import { render, staticRenderFns } from "./SolicitarRelatorio.vue?vue&type=template&id=163f19ea"
import script from "./SolicitarRelatorio.vue?vue&type=script&lang=js"
export * from "./SolicitarRelatorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports